import React from 'react';

function SuccessPage({ sessionId }) {
  return (
    <div style={{
      textAlign: 'center',
      padding: '100px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        fontSize: '4rem',
        marginBottom: '20px'
      }}>&#10003;</div>
      <h1 style={{ color: '#059669', marginBottom: '15px' }}>Payment Successful!</h1>
      <p style={{ fontSize: '1.2rem', color: '#374151', maxWidth: '500px', margin: '0 auto 30px' }}>
        Your website is being built right now. You'll receive an email with your login details
        and website URL within the next few minutes.
      </p>
      <div style={{
        background: '#f0fdf4',
        border: '1px solid #bbf7d0',
        borderRadius: '12px',
        padding: '20px',
        maxWidth: '400px',
        margin: '0 auto 30px'
      }}>
        <h3 style={{ margin: '0 0 10px 0', color: '#166534' }}>What happens next:</h3>
        <ul style={{ textAlign: 'left', listStyle: 'none', padding: 0 }}>
          <li style={{ padding: '5px 0' }}>1. AI generates your website content</li>
          <li style={{ padding: '5px 0' }}>2. Your domain is registered</li>
          <li style={{ padding: '5px 0' }}>3. Website goes live on the internet</li>
          <li style={{ padding: '5px 0' }}>4. Email accounts are set up</li>
          <li style={{ padding: '5px 0' }}>5. You get a welcome email with everything</li>
        </ul>
      </div>
      <p style={{ color: '#6b7280' }}>
        Check your email inbox for login details.
      </p>
    </div>
  );
}

export default SuccessPage;
